import { render } from "./Claim.vue?vue&type=template&id=1902cba2"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"
script.render = render

export default script